"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var AvatarSizeEnum;

(function (AvatarSizeEnum) {
  AvatarSizeEnum["small"] = "small";
  AvatarSizeEnum["medium"] = "medium";
  AvatarSizeEnum["large"] = "large";
})(AvatarSizeEnum = exports.AvatarSizeEnum || (exports.AvatarSizeEnum = {}));

var AvatarTypeEnum;

(function (AvatarTypeEnum) {
  AvatarTypeEnum["rounded"] = "rounded";
})(AvatarTypeEnum = exports.AvatarTypeEnum || (exports.AvatarTypeEnum = {}));

var Avatar =
/** @class */
function (_super) {
  __extends(Avatar, _super);

  function Avatar() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Avatar.prototype.render = function () {
    var _a = this.props,
        uri = _a.uri,
        size = _a.size,
        type = _a.type;
    if (!uri) return null;
    return react_1.default.createElement(AvatarStyled, {
      size: size,
      type: type,
      source: {
        uri: uri
      }
    });
  };

  Avatar.AvatarSize = AvatarSizeEnum;
  Avatar.AvatarType = AvatarTypeEnum;
  return Avatar;
}(react_1.PureComponent);

exports.Avatar = Avatar;
var sizes = (_a = {}, _a[AvatarSizeEnum.small] = 32, _a[AvatarSizeEnum.medium] = 48, _a[AvatarSizeEnum.large] = 64, _a);
var defaultAvatarSize = sizes[AvatarSizeEnum.small];
var AvatarStyled = styled_components_1.default(function (_a) {
  var size = _a.size,
      type = _a.type,
      rest = __rest(_a, ["size", "type"]);

  return react_1.default.createElement(react_native_1.Image, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "%;\n    background-color: #e0dde7;\n"], ["\n    width: ", "px;\n    height: ", "px;\n    border-radius: ", "%;\n    background-color: #e0dde7;\n"])), function (_a) {
  var size = _a.size;
  return sizes[size] ? sizes[size] : defaultAvatarSize;
}, function (_a) {
  var size = _a.size;
  return sizes[size] ? sizes[size] : defaultAvatarSize;
}, function (_a) {
  var type = _a.type;
  return type === AvatarTypeEnum.rounded ? 50 : 0;
});
var templateObject_1;